module.exports = __webpack_public_path__ + "static/img/icon-word.6bc5a17b.svg";